import { WORDPRESS_API } from "shared/constants/api";

export const standardsDocuments = [
  {
    id: "karta-interwencji",
    title: "Karta interwencji",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Karta-interwencji.pdf`
  },
  {
    id: "notatka-ze-zdarzenia",
    title: "Notatka ze zdarzenia",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Notatka-ze-zdarzenia.pdf`
  },
  {
    id: "oswiadczenie-pracownika",
    title: "Oświadczenie pracownika",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Oswiadczenie-pracownika.pdf`
  },
  {
    id: "oswiadczenie-rodzica-i-ucznia",
    title: "Oświadczenie rodzica i ucznia",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Oswiadczenie-rodzica-i-ucznia.pdf`
  },
  {
    id: "standardy-zarzadzenie",
    title: "Standardy Ochrony Małoletnich – zarządzenie dyrektora szkoły",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Standardy-Ochrony-Maloletnich-zarzadzenie-dyrektora-szkoly.pdf`
  },
  {
    id: "standardy-zalacznik",
    title: "Standardy Ochrony Małoletnich – załącznik do zarządzenia",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Standardy-Ochrony-Maloletnich-zalacznik-do-zarzadzenia.pdf`
  }
];